import { Container, Table } from "../../../components";
import { useContext, useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import FormActa from "../../../views/Forms/FormActa";
import { useFormActaStore } from "../../../store/formActaStore";
import { tableData } from "./tableData";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { useDataUserStore } from "../../../store/dataUserStore";
import { handleActas, handlerGetActa } from "../../../handlers/admin.handler";
import { useAdminStore } from "../../../store/adminStore";
import ModalActa from "./components/ModalActa";
import ModalCancelarActa from "../../Public/Actas/components/ModalCancelarActa";
import ActionBar from "./components/ActionBar";
import { toast } from "react-toastify";
import { toastOptions } from "../../../config/toast";
import { asignarSolicitudes } from "../../../services/admin.service";
import Loading from "../../../components/Loading";
import ModalConstatacion from "../../Inspector/ActasInspector/components/ModalConstatacion";
import ModalConstatacionAdmin from "./components/ModalConstatacionAdmin";
// import ModalActa from "./components/ModalActa";
// import ModalActa from "./components/ModalActa";

const ActasAdmin = () => {
  // const { setTipos, setBarrios, setLoading, tipos, barrios, loading, defaultValues, setDefaultValues, formActive, setFormActive, screenMisActas } = useFormActaStore();
  const { loads, modals, handlerModal } = useGeneralAppStore();
  const [cambio, setCambio] = useState(false);
  const {
    actas,
    acta,
    asignarInspector,
    inspectorAsignado,
    solicitudesAsignar,
    setSolicitudesAsignar,
    setAsignarInspector,
    setInspectorAsignado,
    estado_actas,
    refetch,
    setRefetch,
    clearSoliciutdesAsignar,
    setSearchInspector,
    searchInspector,
    filtroFecha,
    toggleFecha,
  } = useAdminStore();
  // const [solicitudesAsignar, ] = useState([]);

  useEffect(() => {
    handleActas({
      estado_id: estado_actas,
      asignarInspector: asignarInspector,
      inspector: searchInspector,
      fecha: !toggleFecha ? null : filtroFecha,
    });
  }, [estado_actas, asignarInspector, searchInspector]);

  useEffect(() => {
    if (cambio) {
      const timer = setTimeout(() => {
        handleActas({
          estado_id: estado_actas,
          asignarInspector: asignarInspector,
          inspector: searchInspector,
          fecha: filtroFecha,
        });
      }, 1000); // 2 segundos de espera
      setCambio(false);
      return () => clearTimeout(timer);
    }
  }, [filtroFecha]);

  useEffect(() => {
    if (cambio) {
      handleActas({
        estado_id: estado_actas,
        asignarInspector: asignarInspector,
        inspector: searchInspector,
        fecha: toggleFecha ? filtroFecha : null,
      });
      setCambio(false);
    }
  }, [toggleFecha]);

  useEffect(() => {
    if (refetch) {
      handleActas({
        estado_id: estado_actas,
        asignarInspector: asignarInspector,
        inspector: searchInspector,
      });
      setRefetch(false);
    }
  }, [refetch]);

  useEffect(() => {
    return () => {
      clearSoliciutdesAsignar();
      setInspectorAsignado(null);
      setAsignarInspector(false);
    };
  }, []);

  return (
    <Container linkBack={"/admin"} titulo={"Solicitudes"} size={"md"}>
      <div className="d-flex" style={{ minHeight: "450px" }} /* style={{ minHeight: "60vh" }} */>
        {/* <AnimatePresence mode="wait"> */}
        <motion.div
          key="table"
          className="w-100 co-12 position-relative"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            delay: 0.5,
            duration: 0.5,
            ease: "easeInOut",
            // exit:{ delay:0.5}
          }}
          style={{ overflow: "hidden", minWidth: "635px" /* height: "435px"  */ }}
        >
          {loads.includes("asignar_solicitudes") && (
            <div
              className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
              style={{ background: "rgba(255,255,255,0.8)", zIndex: "9" }}
            >
              <Loading sizeIcono="50px" sizeLoad="70px" font="16px" />
            </div>
          )}
          <ActionBar setCambio={setCambio} />
          <div className={`border  border-${asignarInspector ? "primary" : "white"} border-1`}>
            <Table
              rowClick={(params) => {
                if (asignarInspector) {
                  if (inspectorAsignado) {
                    setSolicitudesAsignar(params.row.id);
                    // if (solicitudesAsignar.includes(params.row.id)) {
                    //   const filterSolicitudesAsignar = solicitudesAsignar.filter((solicitud) => solicitud != params.row.id);
                    //   setSolicitudesAsignar(filterSolicitudesAsignar)
                    // } else {
                    //   setSolicitudesAsignar((prevState) => [...prevState, params.row.id])
                    // }
                  } else {
                    toast.error("Selecciones un inspector", toastOptions);
                  }
                } else {
                  handlerGetActa(params.id);
                }
              }}
              getRowClassName={
                asignarInspector
                  ? ({ row }) => {
                      // if (row.inspector) {
                      //   return 'inspector'
                      // }
                      if (solicitudesAsignar?.find((solicitud) => solicitud == row.id)) {
                        return "asignado";
                      } else {
                        return "no-asignado";
                      }
                    }
                  : null
                // ({ row }) => {
                //   if (row.inspector) {
                //     return 'inspector'
                //   }
                // }
              }
              height={"660px"}
              loading={["get_actas", "get_acta"].some((item) => loads.includes(item))}
              data={tableData(actas)}
              rowHeight={80}
              sx={{
                ".MuiDataGrid-row.asignado": {
                  // backgroundColor: '#5073FF',
                  backgroundColor: "#2E54F3",
                  color: "white",
                },
                ".MuiDataGrid-row.inspector": {
                  // backgroundColor: '#5073FF',
                  backgroundColor: "#838C94",
                  color: "white",
                },
                ".MuiDataGrid-row.inspector.Mui-hovered": {
                  backgroundColor: "#4366FB",
                },
                ".MuiDataGrid-row.asignado.Mui-hovered": {
                  backgroundColor: "#4366FB",
                },
                ".MuiDataGrid-row.asignado.Mui-selected": {
                  backgroundColor: "#2E54F3",
                  // backgroundColor: '#5073FF',
                },
                ".MuiDataGrid-row.asignado.Mui-selected.Mui-hovered": {
                  backgroundColor: "#2449D8",
                },
              }}
            />
          </div>
        </motion.div>
      </div>

      {modals.includes("get_acta") && (
        <ModalActa
          show={modals.includes("get_acta")}
          onHide={() => {
            handlerModal({ modal: false, modalName: "get_acta" });
          }}
        />
      )}

      {modals.includes("modal_constatacion") && <ModalConstatacionAdmin actaId={acta.id} />}

      {modals.includes("cancelar_acta") && <ModalCancelarActa actaId={acta.id} />}
    </Container>
  );
};
export default ActasAdmin;
